/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CorridorLeaveState,
    CorridorLeaveStateFromJSON,
    CorridorLeaveStateFromJSONTyped,
    CorridorLeaveStateToJSON, 
} from './';

/**
 * 
 * @export
 * @interface TransportPlaceEventState
 */
export interface TransportPlaceEventState {
    /**
     * 
     * @type {string}
     * @memberof TransportPlaceEventState
     */
    eventRuleName?: string;
    /**
     * 
     * @type {number | Array<CorridorLeaveState>}
     * @memberof TransportPlaceEventState
     */
    state?: number | Array<CorridorLeaveState>;
}

export function TransportPlaceEventStateFromJSON(json: any): TransportPlaceEventState {
    return TransportPlaceEventStateFromJSONTyped(json, false);
}

export function TransportPlaceEventStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportPlaceEventState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        eventRuleName: !exists(json, 'eventRuleName') ? undefined : json['eventRuleName'],
        state: !exists(json, 'state') ? undefined : (json['state'] as number | CorridorLeaveState[])
    };
}

export function TransportPlaceEventStateToJSON(value?: TransportPlaceEventState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        eventRuleName: value.eventRuleName,
        state: value.state as number | CorridorLeaveState[]
    };
}


